import { render, staticRenderFns } from "./EbooksReader.vue?vue&type=template&id=1e257daf&scoped=true&"
import script from "./EbooksReader.vue?vue&type=script&lang=js&"
export * from "./EbooksReader.vue?vue&type=script&lang=js&"
import style0 from "./EbooksReader.vue?vue&type=style&index=0&id=1e257daf&lang=scss&scoped=true&"
import style1 from "./EbooksReader.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e257daf",
  null
  
)

export default component.exports